import React, { useEffect, useState } from 'react';
import { Box, Button, Card, Flex, Text } from 'rebass';
import Chat from './landing/Chat';
import Modal from 'styled-react-modal';
import ServiceAvailable from './landing/ServicesAvailable';
import UpcomingVisitLabs from './landing/UpcomingVisitLabs';
import ToDo from './landing/ToDo';
import YourHealthReport from './landing/YourHealthReport';
import Articles from './landing/Articles';
import Recipes from './landing/Recipes';
import { APPOINTMENTS, APPOINTMENTS_NUTRITIONIST, B2B_RESEND_VERIF_EMAIL, GET_MY_WAITLIST, GET_SURVEY_REMINDER, LABS, SCHEDULED_ONBOARDING_CALL } from '../graphql';
import withSession from '../lib/withSession';
import moment from 'moment';
import momentTz from 'moment-timezone';
import styled from 'styled-components';
import { Mutation, Query } from 'react-apollo';
import { withToastManager } from 'react-toast-notifications';
import femaleDoctorIcon from '../static/female_doctor.png';
import LaptopBubble from '../static/LaptopBubble.png';
import Paymentinformation from '../static/Paymentinformation.png';

import PleaseWait from '../components/PleaseWait';
import { FOLLOWUP_SURVEYS_ID } from '../utils/followupSurveysUtils';
import { isToggleActive } from '../components/featureToggle/toggles';
import FilteredBanners from './landing/FilteredBanners';
import { isAsyncAppointment, isMenoAppointment, isWeightLossAppointment } from '../utils/appointments';
import IntakeOptionContinueNoLabModalContent from './labResults2/IntakeOptionContinueNoLabModalContent';
import { AdvertiseSmsLogin } from './landing/AdvertiseSmsLogin';

const BoxRight = styled(Flex)`
  width: 274px;
  justify-content: flex-end;

  @media screen and (max-width: 1300px) {
    display: none;
  }
`;
const BoxRightMobile = styled(Box)`
  @media screen and (min-width: 1300px) {
    display: none;
  }
`;

const PageWrapper = styled(Flex)`
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;

  @media screen and (max-width: 52em) {
    padding-left: 0px;
    padding-right: 0px;
    width: 100vw;
    max-width: 100vw;
  }
`;

const Container = styled(Flex)`
  width: 100%;

  @media screen and (max-width: 480px) {
    width: 100vw;
    max-width: 100vw;
    padding: 0 20px;
  }
`;

const MobileOnly = styled(Flex)`
  display: none;

  @media screen and (max-width: 52em) {
    display: flex;
  }
`;

const DesktopOnly = styled(Flex)`
  display: none;

  @media screen and (min-width: 52em) {
    display: flex;
  }
`;

const Chevron = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none">
      <path
        d="M0.182368 1.08947C0.124114 1.02782 0.0785724 0.955305 0.0483433 0.876059C0.0181142 0.796812 0.00378949 0.712387 0.00618787 0.627604C0.00858624 0.542822 0.0276605 0.459342 0.0623212 0.381931C0.0969819 0.304519 0.14655 0.234693 0.208197 0.176439C0.269843 0.118184 0.34236 0.0726425 0.421607 0.0424134C0.500854 0.0121843 0.585278 -0.00214009 0.670061 0.000258284C0.754843 0.00265666 0.838324 0.0217307 0.915735 0.0563914C0.993146 0.0910522 1.06297 0.140621 1.12123 0.202267L6.60973 6.01363C6.72308 6.13352 6.78623 6.29224 6.78623 6.45723C6.78623 6.62221 6.72308 6.78094 6.60973 6.90083L1.12123 12.7128C1.06336 12.7758 0.993546 12.8267 0.91585 12.8625C0.838154 12.8983 0.754122 12.9183 0.668634 12.9213C0.583146 12.9243 0.497906 12.9104 0.417866 12.8802C0.337827 12.85 0.264582 12.8042 0.202387 12.7455C0.140192 12.6868 0.0902868 12.6163 0.0555696 12.5381C0.0208524 12.4599 0.00201561 12.3756 0.000153087 12.2901C-0.00170943 12.2045 0.0134393 12.1195 0.0447199 12.0399C0.0760006 11.9603 0.122789 11.8877 0.182368 11.8263L5.25246 6.45723L0.182368 1.08947Z"
        fill="white"
      />
    </svg>
  );
};

const TopWarnsActions = ({ text }) => {
  return (
    <>
      <MobileOnly justifyContent={'flex-end'}>
        <Chevron />
      </MobileOnly>
      <DesktopOnly>
        <Button variant="dim" style={{ height: '46px' }}>
          {text || 'Complete'}
        </Button>
      </DesktopOnly>
    </>
  );
};

const Landing = ({ history, session, toastManager }) => {
  return (
    <Query query={APPOINTMENTS_NUTRITIONIST}>
      {({ data: dataNut, loading: loadingNut }) => {
        return (
          <Query query={APPOINTMENTS}>
            {({ data: dataAppointments, loading: loadingAppointments, error: errorAppointments }) => {
              return (
                <Query query={GET_MY_WAITLIST}>
                  {({ data: waitlistData, loading: waitlistLoading }) => {
                    return (
                      <Query query={LABS}>
                        {({ data: labsData, loading: labsLoading }) => {
                          return (
                            <Query query={SCHEDULED_ONBOARDING_CALL}>
                              {({ data: scheduledOnboardingCallData, loading: scheduledOnboardingCallLoading }) => {
                                return (
                                  <LandingInner
                                    history={history}
                                    session={session}
                                    errorAppointments={errorAppointments}
                                    waitlistData={waitlistData}
                                    waitlistLoading={waitlistLoading}
                                    labsData={labsData}
                                    labsLoading={labsLoading}
                                    dataAppointments={dataAppointments}
                                    loadingAppointments={loadingAppointments || loadingNut}
                                    toastManager={toastManager}
                                    dataNutritionists={dataNut}
                                    scheduledOnboardingCallLoading={scheduledOnboardingCallLoading}
                                    scheduledOnboardingCallData={scheduledOnboardingCallData}
                                  />
                                );
                              }}
                            </Query>
                          );
                        }}
                      </Query>
                    );
                  }}
                </Query>
              );
            }}
          </Query>
        );
      }}
    </Query>
  );
};

const LandingInner = ({
  history,
  dataAppointments,
  loadingAppointments,
  errorAppointments,
  labsData,
  labsLoading,
  toastManager,
  dataNutritionists,
  waitlistData,
  waitlistLoading,
  scheduledOnboardingCallLoading,
  scheduledOnboardingCallData,
  session: {
    eligibility,
    intakeStatus,
    menoIntakeStatus,
    weightLossIntakeStatus,
    weightLossIntakeDate,
    isMember,
    intakeDate,
    menoIntakeDate,
    b2b,
    needInsuranceCompletion,
    perpetuousPhysicianConversationId,
    perpetuousGiConversationId,
    mustCompleteBaselineSurvey,
    isWeightLossMember,
    isMetabolicResetMember,
    isCompleteHealthBoostMember,
    diagnoseFull,
  },
}) => {
  const [showPriceIncreaseModal, setShowPriceIncreaseModal] = useState(false);
  const [showCompleteBaselineRibbon, setShowCompleteBaselineRibbon] = useState(false);
  const [showCompleteFURibbon, setShowCompleteFURibbon] = useState(false);
  const [hasAppointments, setHasAppointments] = useState();
  const [pastAppointment, setPastAppointment] = useState();
  const [pastAppointmentMeno, setPastAppointmentMeno] = useState();
  const [pastAppointmentWeightLoss, setPastAppointmentWeightLoss] = useState();
  const [upcomingAppointment, setUpcomingAppointment] = useState();
  const [upcomingAppointmentMeno, setUpcomingAppointmentMeno] = useState();
  const [upcomingAppointmentWeightLoss, setUpcomingAppointmentWeightLoss] = useState();
  const [readyToStartAppt, setReadyToStartAppt] = useState();
  const [readyToStartApptMeno, setReadyToStartApptMeno] = useState();
  const [readyToStartApptWeightloss, setReadyToStartApptWeightloss] = useState();
  const [mustCompleteIntake, setMustCompleteIntake] = useState();
  const [mustCompleteIntakeMeno, setMustCompleteIntakeMeno] = useState();
  const [mustCompleteIntakeWeightloss, setMustCompleteIntakeWeightloss] = useState();
  const [hasFutureAppointments, setHasFutureAppointments] = useState();
  const [hasFutureAppointmentsMeno, setHasFutureAppointmentsMeno] = useState();
  const [hasFutureAppointmentsNutritionist, setHasFutureAppointmentsNutritionist] = useState();
  const [hasFutureAppointmentsWeightloss, setHasFutureAppointmentsWeightloss] = useState();
  const [readyToStartApptNutritionist, setReadyToStartApptNutritionist] = useState();

  const [labs, setLabs] = useState();
  const [hasPendingAsync, setHasPendingAsync] = useState();

  useEffect(
    () => {
      if (!!loadingAppointments) return;

      if (dataAppointments && dataAppointments.appointments) {
        const { appointments } = dataAppointments;
        const hasAppointments = appointments && appointments.length > 0;
        setHasAppointments(hasAppointments);
        if (hasAppointments) {
          const upcomings = appointments
            .filter((item) => {
              if (
                item.status &&
                (item.status === 'f' || item.status === '2') &&
                !isWeightLossAppointment(item.appointmentTypeId) &&
                !isAsyncAppointment(item.appointmentTypeId) &&
                !isMenoAppointment(item.appointmentTypeId)
              ) {
                return true;
              }
              return false;
            })
            .sort((a, b) => {
              const ma = moment(`${a.date} ${a.startTime}`, 'MM/DD/YYYY HH:mm');
              const mb = moment(`${b.date} ${b.startTime}`, 'MM/DD/YYYY HH:mm');
              if (ma.isBefore(mb)) return -1;
              return 1;
            });
          if (upcomings && upcomings.length > 0) {
            setReadyToStartAppt(
              upcomings
                .filter((item) => {
                  try {
                    const dt = momentTz(`${item.date} ${item.startTime}`, 'MM/DD/YYYY HH:mm').tz(item.timezoneName);
                    return dt.isAfter(
                      momentTz()
                        .tz(item.timezoneName)
                        .add(-120, 'minutes'),
                      'minute'
                    );
                  } catch (error) {
                    return false;
                  }
                })
                .find((x) => {
                  const ma = momentTz(`${x.date} ${x.startTime}`, 'MM/DD/YYYY HH:mm').tz(x.timezoneName);
                  return ma.isBefore(
                    momentTz()
                      .tz(x.timezoneName)
                      .add(30, 'minutes')
                  );
                })
            );

            // console.log({ upcomings });
            setUpcomingAppointment(upcomings[0]);
          }

          const upcomingsMeno = appointments
            .filter((item) => {
              if (item.status && (item.status === 'f' || item.status === '2') && !!isMenoAppointment(item.appointmentTypeId)) {
                return true;
              }
              return false;
            })
            .sort((a, b) => {
              const ma = moment(`${a.date} ${a.startTime}`, 'MM/DD/YYYY HH:mm');
              const mb = moment(`${b.date} ${b.startTime}`, 'MM/DD/YYYY HH:mm');
              if (ma.isBefore(mb)) return -1;
              return 1;
            });
          if (upcomingsMeno && upcomingsMeno.length > 0) {
            setReadyToStartApptMeno(
              upcomingsMeno
                .filter((item) => {
                  try {
                    const dt = momentTz(`${item.date} ${item.startTime}`, 'MM/DD/YYYY HH:mm').tz(item.timezoneName);
                    return dt.isAfter(
                      momentTz()
                        .tz(item.timezoneName)
                        .add(-120, 'minutes'),
                      'minute'
                    );
                  } catch (error) {
                    return false;
                  }
                })
                .find((x) => {
                  const ma = momentTz(`${x.date} ${x.startTime}`, 'MM/DD/YYYY HH:mm').tz(x.timezoneName);
                  return ma.isBefore(
                    momentTz()
                      .tz(x.timezoneName)
                      .add(30, 'minutes')
                  );
                })
            );

            setUpcomingAppointmentMeno(upcomingsMeno[0]);
          }

          // console.log({ appointments });
          const upcomingsWeightloss = appointments
            .filter((item) => {
              if (item.status && (item.status === 'f' || item.status === '2') && isWeightLossAppointment(item.appointmentTypeId)) {
                return true;
              }
              return false;
            })
            .sort((a, b) => {
              const ma = moment(`${a.date} ${a.startTime}`, 'MM/DD/YYYY HH:mm');
              const mb = moment(`${b.date} ${b.startTime}`, 'MM/DD/YYYY HH:mm');
              if (ma.isBefore(mb)) return -1;
              return 1;
            });
          if (upcomingsWeightloss && upcomingsWeightloss.length > 0) {
            setReadyToStartApptWeightloss(
              upcomingsWeightloss
                .filter((item) => {
                  try {
                    const dt = momentTz(`${item.date} ${item.startTime}`, 'MM/DD/YYYY HH:mm').tz(item.timezoneName);
                    return dt.isAfter(
                      momentTz()
                        .tz(item.timezoneName)
                        .add(-120, 'minutes'),
                      'minute'
                    );
                  } catch (error) {
                    return false;
                  }
                })
                .find((x) => {
                  const ma = momentTz(`${x.date} ${x.startTime}`, 'MM/DD/YYYY HH:mm').tz(x.timezoneName);
                  return ma.isBefore(
                    momentTz()
                      .tz(x.timezoneName)
                      .add(30, 'minutes')
                  );
                })
            );

            setUpcomingAppointmentWeightLoss(upcomingsWeightloss[0]);
          }

          setHasFutureAppointments(
            upcomings.find((item) => {
              if (
                item.status &&
                (item.status === 'f' || item.status === '2') &&
                !isAsyncAppointment(item.appointmentTypeId) &&
                !isMenoAppointment(item.appointmentTypeId) &&
                !isWeightLossAppointment(item.appointmentTypeId)
              ) {
                const dt = momentTz(`${item.date} ${item.startTime}`, 'MM/DD/YYYY HH:mm').tz(item.timezoneName);
                return dt.isAfter(
                  momentTz()
                    .tz(item.timezoneName)
                    .add(-120, 'minutes'),
                  'minute'
                );
              }
              return false;
            })
          );

          setHasFutureAppointmentsMeno(
            upcomingsMeno.find((item) => {
              if (item.status && (item.status === 'f' || item.status === '2') && isMenoAppointment(item.appointmentTypeId)) {
                const dt = momentTz(`${item.date} ${item.startTime}`, 'MM/DD/YYYY HH:mm').tz(item.timezoneName);
                return dt.isAfter(
                  momentTz()
                    .tz(item.timezoneName)
                    .add(-120, 'minutes'),
                  'minute'
                );
              }
              return false;
            })
          );

          setHasFutureAppointmentsWeightloss(
            upcomingsWeightloss.find((item) => {
              if (item.status && (item.status === 'f' || item.status === '2') && isWeightLossAppointment(item.appointmentTypeId)) {
                const dt = momentTz(`${item.date} ${item.startTime}`, 'MM/DD/YYYY HH:mm').tz(item.timezoneName);
                return dt.isAfter(
                  momentTz()
                    .tz(item.timezoneName)
                    .add(-120, 'minutes'),
                  'minute'
                );
              }
              return false;
            })
          );

          setPastAppointment(
            appointments
              .sort((a, b) => {
                const ma = moment(`${a.date} ${a.startTime}`, 'MM/DD/YYYY HH:mm');
                const mb = moment(`${b.date} ${b.startTime}`, 'MM/DD/YYYY HH:mm');
                if (ma.isAfter(mb)) return -1;
                return 1;
              })
              .find((item) => {
                if (
                  item.status &&
                  item.status !== 'x' &&
                  item.status !== '2' &&
                  item.status !== 'f' &&
                  item.status !== 'o' &&
                  !isAsyncAppointment(item.appointmentTypeId) &&
                  !isMenoAppointment(item.appointmentTypeId) &&
                  !isWeightLossAppointment(item.appointmentTypeId)
                ) {
                  const dt = moment(`${item.date} ${item.startTime}`, 'MM/DD/YYYY HH:mm');
                  return dt.isBefore(momentTz().tz(item.timezoneName), 'minute');
                }
                return false;
              })
          );

          setPastAppointmentMeno(
            appointments
              .sort((a, b) => {
                const ma = moment(`${a.date} ${a.startTime}`, 'MM/DD/YYYY HH:mm');
                const mb = moment(`${b.date} ${b.startTime}`, 'MM/DD/YYYY HH:mm');
                if (ma.isAfter(mb)) return -1;
                return 1;
              })
              .find((item) => {
                if (item.status && item.status !== 'x' && item.status !== 'f' && item.status !== '2' && item.status !== 'o' && isMenoAppointment(item.appointmentTypeId)) {
                  const dt = moment(`${item.date} ${item.startTime}`, 'MM/DD/YYYY HH:mm');
                  return dt.isBefore(momentTz().tz(item.timezoneName), 'minute');
                }
                return false;
              })
          );

          setPastAppointmentWeightLoss(
            appointments
              .sort((a, b) => {
                const ma = moment(`${a.date} ${a.startTime}`, 'MM/DD/YYYY HH:mm');
                const mb = moment(`${b.date} ${b.startTime}`, 'MM/DD/YYYY HH:mm');
                if (ma.isAfter(mb)) return -1;
                return 1;
              })
              .find((item) => {
                if (item.status && item.status !== 'x' && item.status !== 'f' && item.status !== '2' && item.status !== 'o' && isWeightLossAppointment(item.appointmentTypeId)) {
                  const dt = moment(`${item.date} ${item.startTime}`, 'MM/DD/YYYY HH:mm');
                  return dt.isBefore(momentTz().tz(item.timezoneName), 'minute');
                }
                return false;
              })
          );
          setHasPendingAsync(
            appointments.find((item) => {
              if (item.status && (item.status === 'f' || item.status === '2' || item.status === 'o') && isAsyncAppointment(item.appointmentTypeId)) {
                const dt = moment(`${item.date} ${item.startTime}`, 'MM/DD/YYYY HH:mm');
                return dt.isAfter(momentTz().tz(item.timezoneName), 'minute');
              }
              return false;
            })
          );
        }
      }
    },
    [dataAppointments, loadingAppointments]
  );
  useEffect(
    () => {
      if (!!loadingAppointments) return;

      if (dataNutritionists && dataNutritionists.appointmentsNutritionist) {
        const { appointmentsNutritionist } = dataNutritionists;
        const hasAppointments = appointmentsNutritionist && appointmentsNutritionist.length > 0;
        if (hasAppointments) {
          const upcomings = appointmentsNutritionist
            .filter((item) => {
              if (item.status && item.status === 'f') {
                const dt = momentTz(`${item.date} ${item.startTime}`, 'MM/DD/YYYY HH:mm').tz(item.timezoneName);
                return dt.isAfter(
                  momentTz()
                    .tz(item.timezoneName)
                    .add(-120, 'minutes'),
                  'minute'
                );
              }
              return false;
            })
            .sort((a, b) => {
              const ma = moment(`${a.date} ${a.startTime}`, 'MM/DD/YYYY HH:mm');
              const mb = moment(`${b.date} ${b.startTime}`, 'MM/DD/YYYY HH:mm');
              if (ma.isBefore(mb)) return -1;
              return 1;
            });
          if (upcomings) {
            setReadyToStartApptNutritionist(
              upcomings.find((x) => {
                const ma = momentTz(`${x.date} ${x.startTime}`, 'MM/DD/YYYY HH:mm').tz(x.timezoneName);
                return ma.isBefore(
                  momentTz()
                    .tz(x.timezoneName)
                    .add(30, 'minutes')
                );
              })
            );
          }
          setHasFutureAppointmentsNutritionist(
            upcomings.find((item) => {
              if (item.status && item.status === 'f' && !isAsyncAppointment(item.appointmentTypeId)) {
                const dt = momentTz(`${item.date} ${item.startTime}`, 'MM/DD/YYYY HH:mm').tz(item.timezoneName);
                return dt.isAfter(
                  momentTz()
                    .tz(item.timezoneName)
                    .add(-120, 'minutes'),
                  'minute'
                );
              }
              return false;
            })
          );
        }
      }
    },
    [dataNutritionists, loadingAppointments]
  );

  useEffect(
    () => {
      if (!!loadingAppointments) return;
      if (
        !!hasFutureAppointments &&
        (intakeStatus !== 'completed' ||
          !intakeDate ||
          (pastAppointment && pastAppointment.date && momentTz(intakeDate, 'MM-DD-YYYY').isSameOrBefore(momentTz(pastAppointment.date, 'MM/DD/YYYY'), 'day')))
      ) {
        setMustCompleteIntake(true);
      }
      if (
        !!hasFutureAppointmentsMeno &&
        (menoIntakeStatus !== 'completed' ||
          !menoIntakeDate ||
          (pastAppointmentMeno && pastAppointmentMeno.date && momentTz(menoIntakeDate, 'MM-DD-YYYY').isSameOrBefore(momentTz(pastAppointmentMeno.date, 'MM/DD/YYYY'), 'day')))
      ) {
        setMustCompleteIntakeMeno(true);
      }
      if (
        !!hasFutureAppointmentsWeightloss &&
        (weightLossIntakeStatus !== 'completed' ||
          !weightLossIntakeDate ||
          (pastAppointmentWeightLoss && pastAppointmentWeightLoss.date && momentTz(weightLossIntakeDate, 'MM-DD-YYYY').isSameOrBefore(momentTz(pastAppointmentWeightLoss.date, 'MM/DD/YYYY'), 'day')))
      ) {
        setMustCompleteIntakeWeightloss(true);
      }
    },
    [hasFutureAppointments, loadingAppointments, pastAppointment, hasFutureAppointmentsMeno, pastAppointmentMeno, hasFutureAppointmentsWeightloss, pastAppointmentWeightLoss]
  );

  useEffect(
    () => {
      if (labsLoading) return;
      const upcomingLabs = [];
      for (let index = 0; index < labsData.labs.length; index++) {
        const element = labsData.labs[index];
        if (element.status !== 'released') {
          upcomingLabs.push(element);
        }
      }
      setLabs(upcomingLabs);
    },
    [labsData, labsLoading]
  );

  return (
    <PageWrapper flexDirection="row" pt="28px" style={{ marginBottom: '72px' }}>
      <Flex flex={1} flexDirection="column">
        <Flex maxWidth="650px" flexDirection="column">
          {!!isToggleActive('NEW_PRICING_60_ANNOUNCEMENT') && (
            <Card
              onClick={() => setShowPriceIncreaseModal(true)}
              style={{ width: '100%', maxWidth: '700px', backgroundColor: '#FFD5C6', border: '1px solid #FFA482', borderRadius: '10px', cursor: 'pointer' }}
              mb={'32px'}
            >
              <Flex style={{ overflow: 'hidden', padding: '12px 8px' }} alignItems={'center'}>
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M22.2 17.6334L14.0016 3.39563C13.7967 3.04681 13.5042 2.75758 13.1532 2.55662C12.8021 2.35566 12.4046 2.24994 12 2.24994C11.5955 2.24994 11.198 2.35566 10.8469 2.55662C10.4958 2.75758 10.2033 3.04681 9.99847 3.39563L1.80003 17.6334C1.60291 17.9708 1.49902 18.3546 1.49902 18.7453C1.49902 19.1361 1.60291 19.5198 1.80003 19.8572C2.00228 20.2081 2.29425 20.4989 2.64599 20.6997C2.99773 20.9006 3.39658 21.0042 3.80159 21H20.1985C20.6032 21.0039 21.0016 20.9001 21.353 20.6993C21.7044 20.4985 21.9961 20.2078 22.1982 19.8572C22.3956 19.52 22.4998 19.1363 22.5001 18.7456C22.5004 18.3548 22.3969 17.971 22.2 17.6334ZM20.8997 19.1063C20.8282 19.2282 20.7256 19.3289 20.6024 19.3981C20.4792 19.4673 20.3398 19.5024 20.1985 19.5H3.80159C3.66029 19.5024 3.52088 19.4673 3.39765 19.3981C3.27442 19.3289 3.17181 19.2282 3.10034 19.1063C3.0356 18.9966 3.00145 18.8717 3.00145 18.7444C3.00145 18.6171 3.0356 18.4921 3.10034 18.3825L11.2988 4.14469C11.3717 4.02335 11.4748 3.92295 11.598 3.85324C11.7212 3.78354 11.8603 3.7469 12.0019 3.7469C12.1435 3.7469 12.2826 3.78354 12.4058 3.85324C12.529 3.92295 12.6321 4.02335 12.705 4.14469L20.9035 18.3825C20.9676 18.4924 21.0011 18.6176 21.0005 18.7449C20.9998 18.8722 20.965 18.997 20.8997 19.1063ZM11.25 13.5V9.75C11.25 9.55109 11.329 9.36032 11.4697 9.21967C11.6104 9.07902 11.8011 9 12 9C12.1989 9 12.3897 9.07902 12.5304 9.21967C12.671 9.36032 12.75 9.55109 12.75 9.75V13.5C12.75 13.6989 12.671 13.8897 12.5304 14.0303C12.3897 14.171 12.1989 14.25 12 14.25C11.8011 14.25 11.6104 14.171 11.4697 14.0303C11.329 13.8897 11.25 13.6989 11.25 13.5ZM13.125 16.875C13.125 17.0975 13.059 17.315 12.9354 17.5C12.8118 17.685 12.6361 17.8292 12.4305 17.9144C12.225 17.9995 11.9988 18.0218 11.7806 17.9784C11.5623 17.935 11.3619 17.8278 11.2045 17.6705C11.0472 17.5132 10.9401 17.3127 10.8966 17.0945C10.8532 16.8762 10.8755 16.65 10.9607 16.4445C11.0458 16.2389 11.19 16.0632 11.375 15.9396C11.56 15.816 11.7775 15.75 12 15.75C12.2984 15.75 12.5845 15.8685 12.7955 16.0795C13.0065 16.2905 13.125 16.5766 13.125 16.875Z"
                    fill="#344f79"
                  />
                </svg>

                <Flex flexDirection={'column'} ml={3}>
                  <Text fontSize={'16px'} fontWeight={700}>
                    Upcoming Price Change for Visits.
                  </Text>
                  <Text fontSize={'14px'} mt="12px">
                    Starting November 15th, the price for a visit will be increased from $42 to $60.
                    <br />
                    <span style={{ fontWeight: 600 }}>{`Read the annoucement >>`}</span>
                  </Text>
                </Flex>
              </Flex>
            </Card>
          )}

          {intakeStatus === 'disqualified' && (
            <Card style={{ width: '100%', maxWidth: '700px', backgroundColor: '#FFC8BF', borderRadius: '10px' }} mb={'32px'}>
              <Flex style={{ overflow: 'hidden', padding: '12px 8px' }}>
                <img src={femaleDoctorIcon} style={{ marginLeft: '-18px', objectFit: 'contain' }} />
                <Text fontSize={'14px'}>
                  Our evidence-based clinical protocols make sure we offer online care when it is safe to do so. We cannot provide care to those who have not been previously diagnosed with
                  hypothyroidism or who have certain medical conditions. We recommend in-person care with your PCP or endocrinologist.
                </Text>
              </Flex>
            </Card>
          )}
          <FilteredBanners />
          {!!b2b &&
            !!b2b.mustVerify &&
            !b2b.pendingApproval && (
              <Card style={{ width: '100%', maxWidth: '700px', backgroundColor: '#FFC8BF', borderRadius: '10px' }} mb={'32px'}>
                <Flex style={{ overflow: 'hidden', padding: '12px 8px' }} alignItems="center">
                  <img src={femaleDoctorIcon} style={{ marginLeft: '-18px', objectFit: 'contain' }} />
                  <Text fontSize={'14px'} style={{ flex: 1 }}>
                    Please click the link in the email we sent you/to your spouse to activate your account.
                  </Text>
                  <Mutation
                    mutation={B2B_RESEND_VERIF_EMAIL}
                    onCompleted={() => {
                      toastManager.add('Email sent', {
                        appearance: 'success',
                      });
                    }}
                  >
                    {(mutate, { loading, error }) => {
                      return (
                        <Button variant="white" disabled={!!loading} onClick={mutate} ml={2}>
                          Resend
                        </Button>
                      );
                    }}
                  </Mutation>
                </Flex>
              </Card>
            )}
          {!!b2b &&
            !!b2b.pendingApproval && (
              <Card style={{ width: '100%', maxWidth: '700px', backgroundColor: '#FFC8BF', borderRadius: '10px' }} mb={'32px'}>
                <Flex style={{ overflow: 'hidden', padding: '12px 8px' }} alignItems="center">
                  <img src={femaleDoctorIcon} style={{ marginLeft: '-18px', objectFit: 'contain' }} />
                  <Text fontSize={'14px'} style={{ flex: 1 }}>
                    Your eligibility couldn't be confirmed with the information you submitted. Someone from Paloma Health will reach out to you in the next few days.
                  </Text>
                </Flex>
              </Card>
            )}
          {!!needInsuranceCompletion && (
            <Container>
              <Card style={{ width: '100%', maxWidth: '700px', backgroundColor: '#344F7A', borderRadius: '10px' }} mb={'32px'} onClick={() => history.push('/my-insurances/add')}>
                <Flex style={{ overflow: 'hidden', padding: '8px 12px', justifyContent: 'center', alignItems: 'center' }}>
                  <img src={Paymentinformation} style={{ height: '68px', width: '68px', objectFit: 'contain' }} />
                  <Text color="white" fontSize={'14px'} ml={2} flex={1}>
                    Please complete your insurance information
                  </Text>

                  <TopWarnsActions />
                </Flex>
              </Card>
            </Container>
          )}
          {!!mustCompleteIntake && (
            <Container>
              <Card style={{ width: '100%', maxWidth: '700px', backgroundColor: '#344F7A', borderRadius: '10px' }} mb={'32px'} onClick={() => history.push('/intake')}>
                <Flex style={{ overflow: 'hidden', padding: '8px 12px', justifyContent: 'center', alignItems: 'center' }}>
                  <img src={Paymentinformation} style={{ height: '68px', width: '68px', objectFit: 'contain' }} />
                  <Text color="white" fontSize={'14px'} ml={2} flex={1}>
                    Please complete your thyroid care intake form
                  </Text>

                  <TopWarnsActions />
                </Flex>
              </Card>
            </Container>
          )}
          {!!mustCompleteIntakeMeno && (
            <Container>
              <Card style={{ width: '100%', maxWidth: '700px', backgroundColor: '#344F7A', borderRadius: '10px' }} mb={'32px'} onClick={() => history.push('/intake-menopause')}>
                <Flex style={{ overflow: 'hidden', padding: '8px 12px', justifyContent: 'center', alignItems: 'center' }}>
                  <img src={Paymentinformation} style={{ height: '68px', width: '68px', objectFit: 'contain' }} />
                  <Text color="white" fontSize={'14px'} ml={2} flex={1}>
                    Please complete your menopause intake form
                  </Text>
                  <TopWarnsActions />
                </Flex>
              </Card>
            </Container>
          )}
          {!!mustCompleteIntakeWeightloss && (
            <Container>
              <Card style={{ width: '100%', maxWidth: '700px', backgroundColor: '#344F7A', borderRadius: '10px' }} mb={'32px'} onClick={() => history.push('/intake-weightloss')}>
                <Flex style={{ overflow: 'hidden', padding: '8px 12px', justifyContent: 'center', alignItems: 'center' }}>
                  <img src={Paymentinformation} style={{ height: '68px', width: '68px', objectFit: 'contain' }} />
                  <Text color="white" fontSize={'14px'} ml={2} flex={1}>
                    Please complete your weight loss intake form
                  </Text>
                  <TopWarnsActions />
                </Flex>
              </Card>
            </Container>
          )}
          {!!readyToStartAppt && (
            <Container>
              <Card style={{ width: '100%', maxWidth: '700px', backgroundColor: '#344F7A', borderRadius: '10px' }} mb={'32px'} onClick={() => history.push('/visit-visio')}>
                <Flex style={{ overflow: 'hidden', padding: '8px 12px', justifyContent: 'center', alignItems: 'center' }}>
                  <img src={Paymentinformation} style={{ height: '68px', width: '68px', objectFit: 'contain' }} />
                  <Text color="white" fontSize={'14px'} ml={2} flex={1}>
                    Your hypothyroidism appointment is about to start
                  </Text>

                  <TopWarnsActions text={'Start Visit'} />
                </Flex>
              </Card>
            </Container>
          )}
          {!!readyToStartApptMeno && (
            <Container>
              <Card style={{ width: '100%', maxWidth: '700px', backgroundColor: '#344F7A', borderRadius: '10px' }} mb={'32px'} onClick={() => history.push('/visit-visio')}>
                <Flex style={{ overflow: 'hidden', padding: '8px 12px', justifyContent: 'center', alignItems: 'center' }}>
                  <img src={Paymentinformation} style={{ height: '68px', width: '68px', objectFit: 'contain' }} />
                  <Text color="white" fontSize={'14px'} ml={2} flex={1}>
                    Your menopause appointment is about to start
                  </Text>

                  <TopWarnsActions text={'Start Visit'} />
                </Flex>
              </Card>
            </Container>
          )}
          {!!readyToStartApptWeightloss && (
            <Container>
              <Card style={{ width: '100%', maxWidth: '700px', backgroundColor: '#344F7A', borderRadius: '10px' }} mb={'32px'} onClick={() => history.push('/visit-visio')}>
                <Flex style={{ overflow: 'hidden', padding: '8px 12px', justifyContent: 'center', alignItems: 'center' }}>
                  <img src={Paymentinformation} style={{ height: '68px', width: '68px', objectFit: 'contain' }} />
                  <Text color="white" fontSize={'14px'} ml={2} flex={1}>
                    Your weightloss appointment is about to start
                  </Text>

                  <TopWarnsActions text={'Start Visit'} />
                </Flex>
              </Card>
            </Container>
          )}
          {!!readyToStartApptNutritionist && (
            <Container>
              <Card
                style={{ width: '100%', maxWidth: '700px', backgroundColor: '#344F7A', borderRadius: '10px' }}
                mb={'32px'}
                onClick={() => history.push(`/visio-nutritionist/${readyToStartApptNutritionist.provider.id}`)}
              >
                <Flex style={{ overflow: 'hidden', padding: '8px 12px', justifyContent: 'center', alignItems: 'center' }}>
                  <img src={Paymentinformation} style={{ height: '68px', width: '68px', objectFit: 'contain' }} />
                  <Text color="white" fontSize={'14px'} ml={2} flex={1}>
                    Your nutritionist visit is about to start
                  </Text>

                  <TopWarnsActions text={'Start Visit'} />
                </Flex>
              </Card>
            </Container>
          )}
          <Query query={GET_SURVEY_REMINDER}>
            {({ data: dataReminders, loading: loadingReminders }) => {
              return (
                <>
                  {!loadingReminders &&
                    dataReminders &&
                    dataReminders.surveyReminder && (
                      <Container>
                        <Card
                          style={{ width: '100%', maxWidth: '700px', backgroundColor: '#344F7A', borderRadius: '10px' }}
                          mb={'32px'}
                          onClick={() =>
                            history.push(
                              `/establish-followup-survey/${(FOLLOWUP_SURVEYS_ID.find((x) => x.id === dataReminders.surveyReminder) || {}).id}`
                              // `/visio-nutritionist/${readyToStartApptNutritionist.provider.id}`
                            )
                          }
                        >
                          <Flex style={{ overflow: 'hidden', padding: '8px 12px', justifyContent: 'center', alignItems: 'center' }}>
                            <img src={LaptopBubble} style={{ height: '48px', width: '53px', objectFit: 'contain' }} />
                            <Text color="white" fontSize={'14px'} ml={2} flex={1}>
                              Please complete your Care Check-in so we can continue to provide you with the best possible care.
                            </Text>

                            <TopWarnsActions text={`Let's do this`} />
                          </Flex>
                        </Card>
                      </Container>
                    )}
                </>
              );
            }}
          </Query>
          {!!mustCompleteBaselineSurvey &&
            diagnoseFull &&
            diagnoseFull.hasHypo && (
              <Container>
                <Card
                  style={{ width: '100%', maxWidth: '700px', backgroundColor: '#344F7A', borderRadius: '10px' }}
                  mb={'32px'}
                  onClick={() =>
                    history.push(
                      '/establish-baseline'
                      // `/visio-nutritionist/${readyToStartApptNutritionist.provider.id}`
                    )
                  }
                >
                  <Flex style={{ overflow: 'hidden', padding: '8px 12px', justifyContent: 'center', alignItems: 'center' }}>
                    <img src={LaptopBubble} style={{ height: '48px', width: '53px', objectFit: 'contain' }} />
                    <Text color="white" fontSize={'14px'} ml={2} flex={1}>
                      Let's establish your thyroid baseline so that we can track and monitor your thyroid health over time.
                    </Text>

                    <TopWarnsActions text={`Let's do this`} />
                  </Flex>
                </Card>
              </Container>
            )}

          <UpcomingVisitLabs
            hasAppointments={hasAppointments}
            hasFutureAppointments={hasFutureAppointments}
            hasFutureAppointmentsMeno={hasFutureAppointmentsMeno}
            hasFutureAppointmentsWeightloss={hasFutureAppointmentsWeightloss}
            upcomingLabs={labs}
            loadingAppointments={loadingAppointments}
            labsLoading={labsLoading}
            mustCompleteIntake={mustCompleteIntake}
            mustCompleteIntakeMeno={mustCompleteIntakeMeno}
            mustCompleteIntakeWeightloss={mustCompleteIntakeWeightloss}
            hasFutureAppointmentsNutritionist={hasFutureAppointmentsNutritionist}
            waitlistData={(waitlistData || {}).getMyWaitlist}
            waitlistLoading={waitlistLoading}
            scheduledOnboardingCallLoading={scheduledOnboardingCallLoading}
            scheduledOnboardingCallData={scheduledOnboardingCallData && scheduledOnboardingCallData.getScheduledOnboardingCall ? scheduledOnboardingCallData.getScheduledOnboardingCall : []}
          />

          <BoxRightMobile>
            {eligibility.status === 'no_service' &&
              !eligibility.canBookNutritionist && (
                <Card mx={'20px'} mt={3} style={{ width: 'calc(100% - 40px)', maxWidth: '700px', backgroundColor: '#FFC8BF', borderRadius: '10px' }} mb={'32px'}>
                  <Flex style={{ overflow: 'hidden', padding: '8px', fontSize: '14px' }}>
                    <img src={femaleDoctorIcon} style={{ marginLeft: '-18px', objectFit: 'contain' }} />
                    <Text>Video visits are not yet available in your state. We’ll be in touch as soon as we launch in your state.</Text>
                  </Flex>
                </Card>
              )}
            <ToDo
              setShowCompleteBaselineRibbon={setShowCompleteBaselineRibbon}
              setShowCompleteFURibbon={setShowCompleteFURibbon}
              isSmallDevice
              hasFutureAppointments={hasFutureAppointments}
              loadingAppointments={loadingAppointments}
              mustCompleteIntake={mustCompleteIntake}
            />
          </BoxRightMobile>

          <ServiceAvailable
            hasFutureAppointmentsNutritionist={hasFutureAppointmentsNutritionist}
            hasPendingAsync={hasPendingAsync}
            loadingAppointments={loadingAppointments}
            hasAppointments={hasAppointments}
            hasFutureAppointments={hasFutureAppointments}
          />
          <YourHealthReport />
          <Articles />
          <Recipes />
        </Flex>
      </Flex>

      <BoxRight>
        <Flex style={{ position: 'fixed' }} flexDirection={'column'}>
          <ToDo
            setShowCompleteBaselineRibbon={setShowCompleteBaselineRibbon}
            setShowCompleteFURibbon={setShowCompleteFURibbon}
            hasFutureAppointments={hasFutureAppointments}
            loadingAppointments={loadingAppointments}
            mustCompleteIntake={mustCompleteIntake}
          />
          {eligibility.status === 'no_service' &&
            !eligibility.canBookNutritionist && (
              <Card
                mt={3}
                style={{
                  width: '100%',
                  flex: 'initial',
                  padding: '12px',
                  backgroundColor: '#FFC8BF',
                  borderRadius: '10px',
                }}
                mb={'32px'}
              >
                <Flex style={{ overflow: 'hidden', padding: '8px', fontSize: '14px' }}>
                  <img src={femaleDoctorIcon} style={{ marginLeft: '-18px', objectFit: 'contain' }} />
                  <Text>Video visits are not yet available in your state. We’ll be in touch as soon as we launch in your state.</Text>
                </Flex>
              </Card>
            )}
          {!!isMember || !!isWeightLossMember || (!loadingAppointments && (!!pastAppointment || (!!perpetuousPhysicianConversationId && upcomingAppointment))) ? (
            <Chat
              upcomingAppointment={upcomingAppointment}
              pastAppointment={pastAppointment}
              loadingAppointments={loadingAppointments}
              giChat={!!eligibility.canBookNutritionist && perpetuousGiConversationId}
            />
          ) : (
            <>{!!eligibility.canBookNutritionist && perpetuousGiConversationId && <Chat giChat={!!eligibility.canBookNutritionist && perpetuousGiConversationId} />}</>
          )}
        </Flex>
      </BoxRight>

          <AdvertiseSmsLogin />
      <Modal isOpen={showPriceIncreaseModal} onBackgroundClick={() => setShowPriceIncreaseModal(false)} onEscapeKeydown={() => setShowPriceIncreaseModal(false)}>
        {/* <SpecialModalBackground> */}
        <Box
          style={{
            margin: '0 auto',
            alignSelf: 'center',
            borderRadius: '20px',
            position: 'relative',
            backgroundColor: 'white',
            padding: '24px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            width: '100vw',
            maxWidth: '650px',
          }}
        >
          <Flex flexDirection={'column'}>
            <Text textAlign={'center'} fontSize={'20px'} fontWeight={600}>
              Upcoming Price Change for Visits at Paloma Health
            </Text>
            <Text textAlign={'center'} fontSize={'16px'} mt={4}>
              Starting <span style={{ textDecoration: 'underline' }}>November 15th, 2023</span>, the price for a visit at Paloma Health will be increased from $42 to $60. Our commitment to your health
              and well-being remains our top priority. The price change is a step to ensure we can continue delivering the amazing services you’ve come to expect from Paloma Health. We deeply value
              our relationship with you, and we always strive to provide you with the best care possible.
              <br />
              <br />
              To show our appreciation for your continued trust and loyalty, we have an arrangement in place for our existing members. Any visits that you book before November 15th, even if the actual
              visit date is after this date, will still be charged at the current rate of $42. This gives you the flexibility to schedule future visits at the current price if you wish to do so.
            </Text>
            <Button variant={'primary'} mt={4} alignSelf={'center'} onClick={() => setShowPriceIncreaseModal(false)}>
              OK
            </Button>
          </Flex>
        </Box>
        {/* </SpecialModalBackground> */}
      </Modal>
    </PageWrapper>
  );
};

export default withToastManager(withSession(Landing));
